import React from 'react';
import { theme } from '../../../theme';
import { SortDirection } from '../types';
import { DoubleArrowIcon } from '../../../tempIcons/DoubleArrowIconIcon';
import { ArrowUpIcon } from '../../../tempIcons/ArrowUpIcon';
import { ArrowDownIcon } from '../../../tempIcons/ArrowDownIcon';
export const GetSortIcon = ({ sortState, columnId, size }) => {
    if (!sortState || sortState.columnId !== columnId)
        return React.createElement(DoubleArrowIcon, { size: size });
    if (sortState.direction === SortDirection.ascending) {
        return React.createElement(ArrowUpIcon, { color: theme.colors.neutral.ink.dark, size: size });
    }
    return React.createElement(ArrowDownIcon, { color: theme.colors.neutral.ink.dark, size: size });
};
//# sourceMappingURL=GetSortIcon.js.map